import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import SuccessIcon from '../../images/Success.svg'

import '../../css/common-components.css';

import styles from './Success.module.css';

const Success = ({
  title = "Success!",
  message = "Operation completed successfully.",
  buttonText = "Close",
  onButtonClick = (showConfigureOption, isPopup) => {
    // Send message to parent window to close modal/iframe
    if (showConfigureOption) {
      window.location.href = '/configureTemplates' + (isPopup ? "?popup=1" : "");
    } else {
      window.parent.postMessage(JSON.stringify({ action: "DONE" }),"*");
    }
  }
}) => {
  const showConfigureOption = sessionStorage.getItem('show-configure-option');
  sessionStorage.removeItem('show-configure-option');
  buttonText = showConfigureOption ? 'Configure Template' : buttonText;

  const [searchParams] = useSearchParams();
  const isPopup = searchParams.has('popup');

  // Set up message listener for any iframe messages (without auto-sending)
  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.action === "DONE") {
          // Forward to parent if needed
          window.parent.postMessage(JSON.stringify({ action: "DONE" }), "*");
        }
      } catch (e) {
        // Not JSON, ignore
      }
    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div className={styles.successContainer}>
      <div className={styles.successCard}>
        <div className={styles.successIcon}>
            <img src={SuccessIcon} alt="Success" />
        </div>
        <h1 className={styles.successTitle}>
          {title}
        </h1>
        <p className={styles.successMessage}>
          {message}
        </p>
        {(showConfigureOption || isPopup) && (
          <button className={`${showConfigureOption ? styles.navigateBtn : ''} ${isPopup || showConfigureOption ? 'btn-outline-primary' : ''}`.trim()} onClick={() => onButtonClick(showConfigureOption, isPopup)}>
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default Success;
